import { Link } from "react-router-dom";
import { Heart, Mail, MapPin } from "lucide-react";
import Logo from "./Logo";
import { useCashApp } from "./CashAppModal";

const Footer = () => {
  const { open } = useCashApp();
  return (
    <footer className="relative border-t border-purple-100 bg-lavender-50" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 py-16 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-2 max-w-sm">
          <Logo />
          <p className="text-slate-600 text-sm leading-relaxed mt-5">
            Y.E.S. — Youth Empowerment &amp; Support — creates accessible opportunities for young
            people to learn, lead, build confidence, explore their interests, and prepare for their
            future.
          </p>
          <button onClick={open} data-testid="footer-support-btn" className="btn-primary px-5 py-2.5 text-sm mt-6">
            <Heart className="w-4 h-4" /> Invest in Our Youth
          </button>
        </div>
        <div>
          <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-purple-700">Explore</p>
          <ul className="mt-4 space-y-2.5 text-sm">
            {[
              { name: "Home", to: "/" },
              { name: "Programs", to: "/programs" },
              { name: "Events & Media", to: "/media" },
              { name: "Partner With Us", to: "/partner" },
            ].map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="text-slate-600 hover:text-purple-800 transition-colors" data-testid={`footer-link-${l.to === "/" ? "home" : l.to.slice(1)}`}>
                  {l.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-purple-700">Get in touch</p>
          <ul className="mt-4 space-y-3 text-sm text-slate-600">
            <li className="flex items-start gap-2">
              <Mail className="w-4 h-4 mt-0.5 text-purple-600 shrink-0" />
              <a href="mailto:daneisha.green1@yahoo.com" className="hover:text-purple-800 transition-colors" data-testid="footer-email-link">
                daneisha.green1@yahoo.com
              </a>
            </li>
            <li className="flex items-start gap-2">
              <MapPin className="w-4 h-4 mt-0.5 text-purple-600 shrink-0" />
              St. Louis, Missouri
            </li>
            <li>
              <Link to="/admin" className="text-xs text-slate-400 hover:text-purple-700 transition-colors" data-testid="footer-admin-link">
                Admin login
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-purple-100">
        <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-slate-500">
            © {new Date().getFullYear()} Y.E.S. — Youth Empowerment and Support. St. Louis, MO.
          </p>
          <p className="text-xs text-slate-500">
            Photos and videos of youth are published only with media permissions on file.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;